<template>
  <div class='institutional-qnr-view view'>
      <router-view :sections='withQuestionNumbers' :context='context' :adminResponses='adminResponses'/>
  </div>
</template>


<script>
import { getQuestionnaireQuestions } from '@frontend/api/questionnaireApi';

export default {
  name: 'institutional-qnr-view',
  components: { /* Subcomponents */ },
  props: [/* Inputs */],
  data() {
    return {
      questionnaireData: {},
      context: {},
      adminResponses: {},
      clientGroupQuestions: [],
    };
  },
  beforeCreate() {},
  async created() {
    // NEED TO HYDRATE PROSPECT/CLIENT GROUP INFO
    this.questionnaireData = (await getQuestionnaireQuestions('inst-qnr-v1')).data.questionnaire;
    const { prospect, context } = await (await fetch(`/api/v1/get-visitor-context`)).json();
    this.context = { ...context, prospect }
    this.context.name = `${this.context.prospect.first_name} ${this.context.prospect.last_name}`
    console.log('CONTEXT', this.context);
  },
  mounted() {

  },
  updated() {},
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
    sections() {
      return this.questionnaireData?.sections
    },
    filteredQuestions() {
      if (!this.allowedQuestions) return this.sections;

      return this.sections?.map(section => {
        return {
          ...section,
          questions: section.questions.filter(q => {
            return this.allowedQuestions[q.slug]
          }),
        };
      });
    },
    filteredSections() {
      return this.filteredQuestions?.filter(section => {
        return section.questions?.length || section.slug === 'wizard'
      });
    },
    withQuestionNumbers() {
      return this.filteredSections?.map(section => {
        return {
          ...section,
          questions: section.questions.map((question, i) => {
            return { ...question, id: i + 1 };
          }),
        };
      });
    },
    clientGroupID() {
      if (!this.context) return null;
      return this.context.client_group_id;
    },
    allowedQuestions() {
      const slugs = this.clientGroupQuestions;
      if (!slugs?.length) return null;
      
      const allowed = {};
      slugs.forEach(s => allowed[s] = true);
      return allowed;
    }
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
    clientGroupID: {
      immediate: true,
      handler(id) {
        if (!id) return;
        this.getAdminResponses();
        this.getClientGroupQuestions();
      }
    }
  },
  methods: {
    async getAdminResponses() {
      const url = '/api/v1/questionnaire/inst-qnr-v1/admin/responses/' + this.clientGroupID;
      const res = await (await fetch(url)).json();
      this.adminResponses = res.responses;
    },
    async getClientGroupQuestions() {
      const url = `/api/v1/client-groups/${this.clientGroupID}/questions`;
      const res = await (await fetch(url)).json();
      this.clientGroupQuestions = res.available_questions;
    },
  },
};
</script>


<style scoped>
.view {
  background-color: #f6f7f8;
}
</style>
